module.exports = __webpack_public_path__ + "img/happy.8f993a12.png";